<app-walkthrough-slide>
  <div copy class="wt-eyebrow">{{ 'app.pages.auth.walkthrough.pane5.eyebrow' | translate }}</div>
  <h2 copy class="wt-h2">{{ 'app.pages.auth.walkthrough.pane5.title' | translate }}</h2>
  <p copy class="wt-p">{{ 'app.pages.auth.walkthrough.pane5.body' | translate }}</p>

  <div copy class="wt-bul">
    <div class="wt-bul__i wt-bul__i--hi">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane5.bullet.sameEngine' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane5.bullet.nothingFixed' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane5.bullet.payForWhat' | translate }}</span>
    </div>
  </div>

  <!-- Eight tiles, no summary node. Inert (§12 #16). -->
  <div viz class="vgrid">
    @for (tile of tiles; track tile.labelKey) {
      <div class="vmod">
        <ion-icon [name]="tile.icon" aria-hidden="true"></ion-icon>
        <span>{{ tile.labelKey | translate }}</span>
      </div>
    }
  </div>
</app-walkthrough-slide>
